import { Path } from './path';

export class OperationProcess {
  static readonly RECOVERY_CODES = ['045', '045-1'];
  static readonly RECOVERY_OPERATION_TYPE = 'Interna';
  static readonly EXCLUDED_PROCESS_CODE = '2OP';

  constructor(
    public hash: string,
    public sequenceCode: number,
    public operationCode: string,
    public pieceQuantity: number,
    public prevPreparationTime: number,
    public prevExecutionTime: number,
    public description: string,
    public programReference: string,
    public processCode: string,
    public gamaCode: string,
    public paths: Path[],
    public operationType: string,
  ) { }

  isRecovery(): boolean {
    return OperationProcess.RECOVERY_CODES.includes(this.operationCode)
      && this.operationType === OperationProcess.RECOVERY_OPERATION_TYPE
      && this.processCode !== OperationProcess.EXCLUDED_PROCESS_CODE;
  }

  clone() {
    return new OperationProcess(
      this.hash,
      this.sequenceCode,
      this.operationCode,
      this.pieceQuantity,
      this.prevPreparationTime,
      this.prevExecutionTime,
      this.description,
      this.programReference,
      this.processCode,
      this.gamaCode,
      this.paths,
      this.operationType,
    );
  }

  get descriptionCode() {
    return this.description ? `${this.operationCode} - ${this.description}` : this.operationCode;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operation-process.ts